// extracted by mini-css-extract-plugin
export var columnList = "_ex-0";